module.exports = __webpack_public_path__ + "static/media/mobileTransfer.607e4257.svg";